import { AxiosResponse } from "axios";
import { microserviceApiAxios } from "../../microservice-api.axios";
import { microserviceApiRoutes } from "../../microservice-api.routes";

export const getSponsorsList = () => {
  const url = microserviceApiRoutes.v1.agents.sponsors.list();
  return microserviceApiAxios.get(url).then((res: AxiosResponse) => res.data);
};

export const createSponsor = (data: any) => {
  const url = microserviceApiRoutes.v1.agents.sponsors.create();
  return microserviceApiAxios
    .post(url, data)
    .then((res: AxiosResponse) => res.data);
};
